﻿let map: google.maps.Map;
async function initMap(): Promise<void> {
    const mapElement = document.getElementById("map-canvas");
    //Shouldn't be null if required in umbraco.
    const Lat = parseFloat(mapElement.dataset.lat);
    const Lng = parseFloat(mapElement.dataset.lng);
    //Check if valid numbers
    if (isNaN(Lat) || isNaN(Lng)) {
        return;
    }
    
    const { Map } = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;

    map = new google.maps.Map(mapElement as HTMLElement, {
        center: { lat: Lat, lng: Lng },
        zoom: 12,
        streetViewControl: false,
        disableDefaultUI: true,
        zoomControl: true,
        scrollwheel: false,
        maxZoom: 15,
        styles: [
            {
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    }
                ]
            },
            {
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#616161"
                    }
                ]
            },
            {
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    }
                ]
            },
            {
                "featureType": "administrative.land_parcel",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#bdbdbd"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#eeeeee"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#757575"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e5e5e5"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#757575"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#dadada"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#616161"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                ]
            },
            {
                "featureType": "transit.line",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e5e5e5"
                    }
                ]
            },
            {
                "featureType": "transit.station",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#eeeeee"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#c9c9c9"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                ]
            }
        ]
    });

    const marker = new google.maps.Marker({
        position: new google.maps.LatLng(Lat, Lng),
        icon: {
            url: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent('<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29.24 32.49"><defs><style>.cls-1{fill:#fff;}.cls-2{fill:#1d2d4e;}</style></defs><path class="cls-1" d="M11.26,20.45V12.74l7.12,7.64c.26.28.38.36.38.54s-.2.16-.4.16v.24H22v-.27c-.39,0-.53-.16-.53-.6V10.16c0-.44.14-.59.53-.59V9.32H18.48V9.6c.48,0,.52.15.52.59v7.13l-6.84-7.2Q12,9.91,12,9.82c0-.18.15-.26.53-.26V9.32H8.3v.27c.43,0,.47.16.47.6V20.48c0,.44,0,.6-.47.6v.24h3.5v-.27C11.36,21.05,11.26,20.89,11.26,20.45Z" transform="translate(-0.54 -0.7)"/><path class="cls-2" d="M18,29.67h0A14.63,14.63,0,0,0,29.78,15.32v0A14.62,14.62,0,1,0,12.33,29.66h0L14.74,33a.55.55,0,0,0,.88,0ZM11.8,21.32H8.3v-.24c.47,0,.47-.16.47-.6V10.19c0-.44,0-.6-.47-.6V9.32h4.18v.24c-.38,0-.53.08-.53.26s.07.16.21.3L19,17.32V10.19c0-.44,0-.59-.52-.59V9.32H22v.25c-.39,0-.53.15-.53.59V20.45c0,.44.14.6.53.6v.27H18.36v-.24c.2,0,.4,0,.4-.16s-.12-.26-.38-.54l-7.12-7.64v7.71c0,.44.1.6.54.6Z" transform="translate(-0.54 -0.7)"/></svg>'),
            size: new google.maps.Size(200, 200),
            scaledSize: new google.maps.Size(32, 32),
            anchor: new google.maps.Point(16, 16),
            labelOrigin: new google.maps.Point(16, 16)
        },
        map: map,
    });
}


export { initMap } 